const UPDATE_ORDERS_CHART_DATA = 'UPDATE_ORDERS_CHART_DATA';

export { UPDATE_ORDERS_CHART_DATA };
